import { CASES } from './constants';

export const updateDealVersion = (payload) => {
    return { type: CASES.UPDATE_DEAL_VERSION, payload };
};

export const updateDealVersionSearchForm = ({ key, data }) => {
    return {
        type: CASES.UPDATE_DEAL_VERSION_SEARCH_FORM,
        payload: { key, data },
    };
};

export const clearDealVersion = () => {
    return { type: CASES.CLEAR_DEAL_VERSION, payload: {} };
};
